/**
 * アプリの初期化(親からのショップ情報取得とアクセストークン取得)を担う
 * アクセストークンを返す
 */
import { useState, useEffect } from 'react';
import { CUSTOMER_API_URL } from '../../constants';
import axios from 'axios';
import { useEmitMessage } from '../common/useEmitMessage';

export const useAppInitialize = (): string => {

  const [token, setToken] = useState('');
  const emitMessage = useEmitMessage();

  useEffect(() => {
    const handleRecieveMessage = async (event: MessageEvent) => {

      const { code, styleTexts, styleUrls, shopId, customerId } = event.data;

      if (code === undefined || !styleTexts || !styleUrls || !shopId) return;

      // shopId/customerIdを利用したlocalStorageへの保管をしたい(box-accountを参考に)

      try {
        const response = await axios.post(`${CUSTOMER_API_URL}?action=token`, { code });

        setToken(response.data);
        injectStyleTextElementsToBody(styleTexts);
        injectStyleUrlElementsToBody(styleUrls);

        window.removeEventListener('message', handleRecieveMessage);

      } catch(error) {

        if (axios.isAxiosError(error)) {
          if (!error.response) throw new Error(error.message);
          if (error.response.status >= 500) throw error;
          emitMessage('app-not-get-token', 'keep');
        }
      }
    };

    window.addEventListener('message', handleRecieveMessage);

    // theme側に対して初回となるpostMessageを送信する
    // これにより、上記のhandleRecieveMessageに記述しているデータが
    // このiframeに対してpostされる
    window.parent.postMessage({ action: 'initialize' }, '*');

    return () => window.removeEventListener('message', handleRecieveMessage);
      
  }, []);

  return token;
};

// functions

const injectStyleTextElementsToBody = (styleTexts: string[]) => {
  styleTexts.forEach(styleText => {
    const style = document.createElement('style');
    style.innerText = styleText;
    document.body.appendChild(style);
  });
};

const injectStyleUrlElementsToBody = (styleUrls: string[]) => {
  styleUrls.forEach(url => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.body.appendChild(link);
  });
};